// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"3f38caf1","217":"08e698a8","280":"9da1b7e7","453":"dbb66f8d","529":"922cca05","866":"63fdfd18"}[chunkId] + ".chunk.js";
};